export default {
    SUBMIT_IMPORTAR_VERRACOS_EXCEL: 'SUBMIT_IMPORTAR_VERRACOS_EXCEL',
    SUBMIT_IMPORTAR_VERRACOS_EXCEL_SUCCESS: 'SUBMIT_IMPORTAR_VERRACOS_EXCEL_SUCCESS',
    ABRIR_MODAL_IMPORTAR_VERRACOS_EXCEL: 'ABRIR_MODAL_IMPORTAR_VERRACOS_EXCEL',
    CERRAR_MODAL_IMPORTAR_VERRACOS_EXCEL: 'CERRAR_MODAL_IMPORTAR_VERRACOS_EXCEL',
    SUBIR_ARCHIVOS_IMPORTAR_VERRACOS_EXCEL: 'SUBIR_ARCHIVOS_IMPORTAR_VERRACOS_EXCEL',
    DESCARGAR_PLANTILLA_EXCEL_VERRACOS_EXCEL: 'DESCARGAR_PLANTILLA_EXCEL_VERRACOS_EXCEL',
    DESCARGAR_VERRACOS_EXCEL: 'DESCARGAR_VERRACOS_EXCEL'
  }